import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    card: {
      minWidth: 275,
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
    },
  };

const UsefulItem = (props) => {
    const { classes, title } = props;

    return(
        <Card className={classes.card}>
            <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                    {title}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default withStyles(styles)(UsefulItem);